import { Inline, Span, Spinner, Text } from "@hopper-ui/components";
import { CheckmarkIcon, WarningIcon } from "@hopper-ui/icons";
import type { ReactNode } from "react";
import { useRelativeTime } from "@sg-protect/components";
import type { SaveStatus } from "../layout/ReviewCreationWizardLayout.tsx";

interface SavedIndicatorProps {
    saveStatus: SaveStatus;
    lastSavedAt: string;
}

export function SavedIndicator({ saveStatus, lastSavedAt }: SavedIndicatorProps) {
    if (saveStatus === "saving") {
        return <IndicatorLayout icon={<Spinner size="sm" aria-label="Saving" />}>Saving…</IndicatorLayout>;
    }

    if (saveStatus === "error") {
        return (
            <IndicatorLayout icon={<WarningIcon size="sm" color="status-negative" />}>Couldn't save</IndicatorLayout>
        );
    }

    return <SavedLabel lastSavedAt={lastSavedAt} />;
}

interface SavedLabelProps {
    lastSavedAt: string;
}

function SavedLabel({ lastSavedAt }: SavedLabelProps) {
    const relativeTime = useRelativeTime(lastSavedAt);

    return (
        <IndicatorLayout icon={<CheckmarkIcon size="sm" color="status-positive" />}>
            <Span>Saved as draft</Span> · <Span>{relativeTime}</Span>
        </IndicatorLayout>
    );
}

interface IndicatorLayoutProps {
    icon: ReactNode;
    children: ReactNode;
}

function IndicatorLayout({ icon, children }: IndicatorLayoutProps) {
    return (
        <Inline gap="inline-xs" alignY="center">
            {icon}
            <Text size="sm" color="neutral-weak" fontStyle="italic" data-public>
                {children}
            </Text>
        </Inline>
    );
}
